<template>
	<aside class="c-siteSelector" aria-label="Site Selector">
		<SlideInOverlay
			:is-open="isOpen"
			placement="right"
			@close="close"
			@enter="enter"
			class="c-siteSelector__overlay"
		>
			<template v-slot:header>
				<slot name="header"></slot>
				<button
					:aria-label="translations['Close']"
					class="close"
					@click="close"
				>
					<CloseIcon></CloseIcon>
				</button>
			</template>
			<template v-slot:body>
				<div class="sites">
					<div
						v-for="site in sites"
						:key="site.id"
						class="sites__site"
						:class="{ 'sites__site--active': site.id == selected.id }"
						@click="select(site)"
					>
						<div class="info">
							<Component :is="site.flag + 'Flag'"></Component>
							{{ site.name }}
						</div>
						<div class="checkmark">
							<CheckmarkIcon></CheckmarkIcon>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<button
					class="o-btn o-btn--fill"
					:class="{ 'o-btn--disabled': current.id == selected.id }"
					@click="changeSite"
				>
					{{ translations['Update'] }}
				</button>
			</template>
		</SlideInOverlay>
	</aside>
</template>

<script>
import { mapState } from 'vuex';
import request from '@/vue/mixins/request.js';
import SlideInOverlay from '@/vue/components/objects/SlideInOverlay.vue';

// ICONS
import CloseIcon from '@web/assets/icon/close.svg';
import CheckmarkIcon from '@web/assets/icon/checkmark.svg';

import DKFlag from '@web/assets/flag/DK.svg';
import SEFlag from '@web/assets/flag/SE.svg';

export default {
	name: 'SiteSelector',
	mixins: [request],
	components: {
		SlideInOverlay,
		CloseIcon,
		CheckmarkIcon,

		SEFlag,
		DKFlag,
	},
	props: {
		current: Object,
		sites: Object,
	},
	computed: {
		...mapState({
			isOpen: (state) => state.status.siteSelector,
		}),
	},
	data: () => {
		return {
			selected: null,
		};
	},
	methods: {
		select(site) {
			this.selected = site;
		},
		changeSite() {
			if (this.current.id !== this.selected.id) {
				window.location.href = this.selected.url;
			}
		},
		close() {
			this.$store.dispatch('status/closeSiteSelector');
		},
		enter() {
			this.changeSite();
		},
	},
	created() {
		this.selected = this.current;
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';

.c-siteSelector {
	height: 100%;

	.inner {
		&__header {
			width: 100%;
			padding-inline: 40px;
			padding-top: 40px;
			margin-bottom: 16px;

			display: flex;
			justify-content: space-between;

			h2 {
				margin-bottom: 16px;
			}

			.close {
				cursor: pointer;
				width: 35px;
				height: 35px;

				display: flex;
				align-items: flex-start;
				justify-content: flex-end;

				svg {
					width: 16px;
					height: 16px;
				}
			}
		}
		&__body {
			padding-inline: 40px;
			.sites {
				&__site {
					padding-top: 24px;
					padding-bottom: 24px;

					display: flex;
					align-items: center;
					justify-content: space-between;

					border-bottom: $e-border;
					font-weight: $f-semibold;
					transition: $t-hover;
					cursor: pointer;

					.info {
						display: flex;
						align-items: center;
						svg {
							margin-right: 8px;
						}
					}

					.checkmark {
						display: flex;
						align-items: center;

						opacity: 0;
						transition: $t-hover;

						svg {
							widows: 21px;
							height: 16px;
						}
					}

					&--active {
						pointer-events: none;

						color: $c-grey-text;
						cursor: default;

						.checkmark {
							opacity: 1;
						}
					}

					&:first-child {
						border-top: $e-border;
					}
				}
			}
		}

		&__footer {
			border-top: $e-border;
			padding-top: 24px;
			padding-bottom: 24px;
			padding-inline: 40px;
			flex-direction: column;
			display: flex;
		}
	}
}

@media all and (max-width: 768px) {
	.c-siteSelector {
		.inner {
			&__header {
				padding-inline: 30px;
			}
			&__body {
				padding-inline: 30px;
			}
			&__footer {
				padding-inline: 30px;
			}
		}
	}
}

@media all and (max-width: 450px) {
	.c-siteSelector {
		.inner {
			&__header {
				padding-inline: $s-side;
			}
			&__body {
				padding-inline: $s-side;
			}
			&__footer {
				padding-inline: $s-side;
			}
		}
	}
}
</style>
